import {formatNumber} from "../../../components/FormatNumber";
import {copyPaymentTermsForInvoiceBill} from "./helper/copyPaymentTermsForInvoiceBill";
import {copyCustomFields} from "./helper/copyCustomFields";
import {deleteAllIds} from "./helper/deleteAllIds";
import {getInitData} from "./helper/getInitData";
import {getParentUrl} from "../helpers/getParentUrl";
import { processFormItems } from "./helper/processFormItems";
import { select } from "redux-saga/effects";
import { showConfirmationModalPromise } from "./helper/Modal/showConfirmationModalPromise";
import { SubscriptionCheck } from "../../../components/Access/helper/subscription/SubscriptionCheck";
import { SubscriptionScopeKey } from "../../../components/Access/helper/subscription/enum/SubscriptionScopeKey";
import _ from "lodash";
import { readAutosaveStorage } from "../../LocalStorage/helpers/AutosaveTransactions/readStorage";
import { showWillOverrideAutosaveDataPromise } from "./helper/Modal/showWillOverrideAutosaveDataPromise";
import { Type } from "../helper";
import { put } from "../../../shared/SagaService";
import { readOutstanding } from "./helper/readOutstanding";
import { PageType } from "../../../enums/PageType";
import TransactionActions from "bukku/redux/Transaction/actions";

const {
    changeLinkItems,
} = TransactionActions;

// Case 4: Transfer
// - Different Type but same category
// - Mainly to transfer items (from one to another)
// - Examples:
//      - Quotations => Sales Order
//      - Sales Order => Delivery Order
//      - Delivery Order => Invoice
export function* transfer(transactionType, originType, originTransaction = {}) {
    // Check if there's any autosaved data for the transaction type, and prompt modal if there is
    const { data, last_saved } = yield readAutosaveStorage(transactionType) || {};

    if (data) {
        const autosaveModalRef = yield select(state => state.Transaction.autosaveModalRef);
        const isProceed = yield showWillOverrideAutosaveDataPromise(transactionType, autosaveModalRef, last_saved, 'transfer');
        if (!isProceed)
            return {isProceed: false, transaction: null};
    }

    // Init Data
    const initData = yield getInitData(transactionType);
    const productList = yield select(state => state.List.productList);
    const settings = yield select(state => state.List.settings);
    const contacts = yield select(state => state.List.contacts);
    const companyCurrencyCode = yield select(state => state.Auth.companyCurrencyCode);
    const companyCountryCode = yield select(state => state.Auth.companyCountryCode);

    const isMalaysianCompany = companyCountryCode === 'MY';

    // Term Items (for Invoice + Bills)
    const termItems = yield copyPaymentTermsForInvoiceBill(transactionType, originTransaction);

    // Custom Fields
    const fields = yield copyCustomFields(transactionType, originType, originTransaction);

    const hasTagSub = SubscriptionCheck.withKeys(SubscriptionScopeKey.TAG).hasSubscriptionTo();
    const hasMultiCurrencySub =
        SubscriptionCheck.withKeys(SubscriptionScopeKey.MULTI_CURRENCY).hasSubscriptionTo();
    const hasCustomFieldSub =
        SubscriptionCheck.withKeys(SubscriptionScopeKey.CUSTOM_FIELD).hasSubscriptionTo();

    const contact = contacts?.find(c => c.id === originTransaction.contact_id);
    console.log('aaa transfer', {
        isMalaysianCompany,
        contacts,
        contact,
        transactionType,
        originType,
        originTransaction,
        initData,
        termItems,
        fields,
        hasTagSub,
        hasMultiCurrencySub,
        hasCustomFieldSub,
        isMyInvoisEnabled: settings?.is_myinvois_submission_enabled,
    });

    const transaction = {
        ...initData,
        ...originTransaction,
        type: transactionType,

        // Copy from initData
        date: initData.date,
        due_date: initData.due_date, // For bill
        number: initData.number,
        currency_code: hasMultiCurrencySub ? originTransaction.currency_code : companyCurrencyCode,
        exchange_rate: hasMultiCurrencySub ? originTransaction.exchange_rate : 1,

        link_items: initData.link_items || [], // ignore: []
        linked_items: [],
        remarks: initData.remarks,
        status: initData.status,

        term_items: termItems,
        fields: hasCustomFieldSub ? fields : undefined,

        // Copy from originTransaction
        amount: formatNumber(originTransaction.amount, 2, undefined, false),
        account2_id: originTransaction.account2_id || initData.account2_id,

        // Check subscription
        tag_ids: hasTagSub ? originTransaction.tag_ids || [] : undefined,
    };

    // If Sales / Purchase Module
    if (['/sales', '/purchases'].includes(getParentUrl(transactionType)))
        transaction.number2 = originTransaction.number;

    // MyInvois transactions
    if ([
        Type.sale_invoice,
        Type.sale_credit_note,
        Type.purchase_bill,
        Type.purchase_credit_note,
    ].includes(transactionType) &&
        isMalaysianCompany && settings?.is_myinvois_submission_enabled
    )
        transaction.myinvois_action = contact.default_myinvois_action;

    // ORGINAL (BEFORE Oct 2)
    // // Form Items
    // if (originTransaction.form_items) {
    //     transaction.form_items = originTransaction.form_items.map(item => {
    //         // Ignore subtitle and subtotal lines
    //         if ([RowType.subtitle, RowType.subtotal].includes(item.type))
    //             return item;

    //         // Adding transfer transaction information
    //         const formItem = {
    //             ...item,
    //             transfer_transaction: {
    //                 id: originTransaction.id,
    //                 type: originTransaction.type,
    //                 number: originTransaction.number,
    //                 date: originTransaction.date,
    //             },
    //             transfer_item_id: item.id,
    //             quantity: item.balance_quantity,
    //         };

    //         return (formItem.quantity === 0) ? false : formItem;
    //     });

    //     transaction.form_items = transaction.form_items.filter(i => !!i);
    // }

    const hasTagChange = !_.isEqual(originTransaction.tag_ids || [], transaction.tag_ids || []);
    const hasCurrencyCodeChange = originTransaction.currency_code !== transaction.currency_code;
    // compare the 2 transactions' fields without 'id'.
    // fields.length === 0 means that the 2 transactions don't share any same fields
    // const hasFieldChange = (fields || []).length === 0 ? false : _.differenceWith(
    //     originTransaction.fields,
    //     transaction.fields,
    //     (a, b) => _.isEqual(_.omit(a, 'id'), _.omit(b, 'id'))).length !== 0;
    const hasFieldChange = !hasCustomFieldSub && !!(fields || []).find(f => f.value);

    // Form Items
    if (originTransaction.form_items) {
        const {
            // processedFormItems,
            finalFormItems,
            nonBaseUomItems,
            hasTaxChange,
            hasLocationChange,
            removedBundles,
        } = processFormItems({
            formItems: originTransaction.form_items,
            productList,
            settings,
            initType: 'transfer',
            originTransaction,
        });

        // console.log({processedFormItems, finalFormItems, nonBaseUomItems});
        // REMOVE non-base uom items
        if (nonBaseUomItems?.length || removedBundles?.length ||
            hasTagChange || hasCurrencyCodeChange || hasFieldChange || hasLocationChange || hasTaxChange
        ) {
            // yield to make the Modal.confirm synchronous by using Promise
            yield showConfirmationModalPromise(
                nonBaseUomItems,
                removedBundles,
                {
                    hasTagChange, hasCurrencyCodeChange, hasFieldChange, hasLocationChange, hasTaxChange,
                })
                .then(() => {
                    // User clicked OK - remove invalid form items with non-base UOM
                    transaction.form_items = finalFormItems;
                })
                .catch(() => {
                    // // User clicked Cancel - retain all form items
                    // transaction.form_items = processedFormItems;
                });
        }
        else {
            transaction.form_items = finalFormItems;
        }
    }

    // For Invoices and Bills, read outstanding transactions
    if ([Type.sale_invoice, Type.purchase_bill].includes(transactionType)) {
        const txnTypeToRead =
            transactionType === Type.sale_invoice ? Type.sale_refund : Type.purchase_refund;

        yield readOutstanding(PageType.transfer, txnTypeToRead, transaction);
        const fetchedLinkItems = yield select(state => state.Transaction.linkItems);

        transaction.link_items = fetchedLinkItems;
        yield put(changeLinkItems(fetchedLinkItems));
    }

    // Remove all ids
    console.log('aaa transfer final', deleteAllIds(transaction));
    return {
        isProceed: true,
        transaction: deleteAllIds(transaction),
    };
}
